import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector } from "react-redux";
// CUSTOM HOOKS
import useGetAllRolesLight from "../../../customHooks/GET_requests/useGetAllRolesLight";
// INTERFACES
import { RoleLightInterface } from "../../../interfaces/Roles.interface";
import { SelectRoleInterface } from "../../../interfaces/Global.interface";
import { RootState } from "../../../app/store";

function SelectRolesLight({ value, onChangeIdRole, disabledInput }: SelectRoleInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option, OptGroup } = Select;
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [organizationGroups, setOrganizationGroups] = useState<[{ id: ""; name: "" }]>([{ id: "", name: "" }]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { globalOrganizationId } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { rolesLight: roles, isLoadingGetAllRolesLight } = useGetAllRolesLight({ orgId: globalOrganizationId });

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const uniqueOrganizations = () => {
		const d: any = roles
			.map((item) => item.organization)
			.filter((org, index, self) => index === self.findIndex((o) => o.id === org.id));
		setOrganizationGroups(d);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		uniqueOrganizations();
	}, [roles]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Select
			className='generalStyles__width100'
			disabled={disabledInput}
			showSearch
			optionFilterProp='children'
			placeholder={t("report.selectBank")}
			value={value}
			size='small'
			onChange={onChangeIdRole}
			loading={isLoadingGetAllRolesLight}
		>
			{organizationGroups.map((group: any) => (
				<OptGroup key={group.id} label={`ORGANIZATION / ${group.name}`}>
					{roles
						.filter((role: RoleLightInterface) => role && role.organization && role.organization.id === group.id)
						.map((server: { id: string; name: string }) => (
							<Option key={server.id} value={server.id}>
								{server.name}
							</Option>
						))}
				</OptGroup>
			))}
		</Select>
	);
}

export default SelectRolesLight;
